import { CompanyDetails } from '../../models/company-details';

export interface DetailsState {
    details: CompanyDetails;
}

export const initialState: DetailsState = {
    details: {} as CompanyDetails
};
